// firm-selection.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface selectedFirmName {
  id: number;
  name: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FirmSelectionService {
  private selectedFirmName = new BehaviorSubject<selectedFirmName | null>(null);
  selectedFirmName$ = this.selectedFirmName.asObservable();

  constructor() {
    this.loadInitialFirm();
  }

  private loadInitialFirm() {
    const storedFirm = sessionStorage.getItem('selected_firm');
    if (storedFirm) {
      try {
        const firm = JSON.parse(storedFirm);
        this.selectedFirmName.next(firm);
      } catch (e) {
        console.error("Failed to parse stored firm from sessionStorage", e);
      }
    } else {
      // Fallback to legacy localStorage firm_id if needed, 
      // but we prefer the full object from sessionStorage
      const legacyFirmId = localStorage.getItem('firm_id');
      if (legacyFirmId) {
        console.warn("Found legacy firm_id in localStorage, but no full firm object in sessionStorage.");
      }
    }
  }

  setselectedFirmName(firm: selectedFirmName) {
    this.selectedFirmName.next(firm);
    sessionStorage.setItem('selected_firm', JSON.stringify(firm));
    localStorage.setItem('firm_id', firm.id.toString());
    console.log("firm data in firm selection", firm);
  }

  getselectedFirmName(): selectedFirmName | null {
    return this.selectedFirmName.value;
  }

  /** Used only on logout so the next login does not inherit the previous firm. */
  clearSelectedFirm(): void {
    this.selectedFirmName.next(null);
    sessionStorage.removeItem('selected_firm');
    localStorage.removeItem('firm_id');
  }

  isGstFirm(status: any, name: string): boolean {
    const s = status?.toString().toLowerCase();
    const n = name?.toLowerCase();

    if (n?.includes('non-gst') || n?.includes('non gst')) {
      return false;
    }

    return ['gst', 'yes', '1', 'true', 'registered'].includes(s) ||
      n?.includes('gst');
  }
}
